import React from "react";
import emptyStateVector from "../assets/empty-state-screen.svg";

const EmptyState = (props) => {
  const { title, imageWidth } = props;
  return (
    <div className="container font-proxima-nova">
      <div className="row">
        <div className="col-12">
          <img
            src={emptyStateVector}
            alt="People erjoicing their win - illustration."
            className="d-block m-auto"
            style={{
              width: `${imageWidth}%`,
            }}
          />
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-12 text-center">
          <h5 className="no-offers-title">{title}</h5>
        </div>
      </div>
    </div>
  );
};
export default EmptyState;
